import { render, staticRenderFns } from "./CustosFixosVariaveisNoCustoTotalAbsoluto.vue?vue&type=template&id=6858107e&scoped=true&"
import script from "./CustosFixosVariaveisNoCustoTotalAbsoluto.vue?vue&type=script&lang=js&"
export * from "./CustosFixosVariaveisNoCustoTotalAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6858107e",
  null
  
)

export default component.exports